// extracted by mini-css-extract-plugin
export default {"wrapper":"CartIcon_wrapper__jBBV4","icon":"CartIcon_icon__bOwCz","badge":"CartIcon_badge__Ral7K"};